// update state
const setActionFooter = (payload) => {
    return {
        type: "ACTIONFOOTER",
        payload
    }
}

export default setActionFooter;


// WEBPACK FOOTER //
// ./src/actions/setActionFooter.js